import { render, staticRenderFns } from "./SliderCSS.vue?vue&type=template&id=e1a560d8&"
import script from "./SliderCSS.vue?vue&type=script&lang=js&"
export * from "./SliderCSS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports